// Core
import { takeEvery, all, call } from 'redux-saga/effects';
import { SagaIterator } from '@redux-saga/core';


// Workers
import { 
    fetchTtnOpen,
    fetchTtnParametersCurrent,
    comingNomenclatureReportWorker,
    comingInvoiceReportWorker,
    fetchInvoiceParametersCurrent,
    fetchReportPassportWorker,
    fetchSetReportPassportWorker
 } from './worker';
import {
    getTtnParameters,
    setTtn,
    comingNomenclatureReport,
    getInvoice,
    setInvoice,
    getReportPassport,
    setReportPassport
} from '../actions';

function* watchFetchCurrent(): SagaIterator {
    yield takeEvery(getTtnParameters.async, fetchTtnParametersCurrent);
}
function* watchFetchOpen(): SagaIterator {
    yield takeEvery(setTtn.async, fetchTtnOpen);
}
function* comingNomenclatureReportWatch(): SagaIterator {
    yield takeEvery(comingNomenclatureReport.async, comingNomenclatureReportWorker);
}

function* watchFetchInvoiceCurrent(): SagaIterator {
    yield takeEvery(getInvoice.async, fetchInvoiceParametersCurrent);
}
function* watchFetchInvoiceOpen(): SagaIterator {
    yield takeEvery(setInvoice.async, comingInvoiceReportWorker);
}

function* watchFetchReportPassport(): SagaIterator {
    yield takeEvery(getReportPassport.async, fetchReportPassportWorker);
}

function* watchFetchSetReportPassport(): SagaIterator {
    yield takeEvery(setReportPassport.async, fetchSetReportPassportWorker);
}


export function* watchReport(): SagaIterator {
    yield all([
        call(watchFetchCurrent),
        call(watchFetchOpen),
        call(comingNomenclatureReportWatch),
        call(watchFetchInvoiceCurrent),
        call(watchFetchInvoiceOpen),
        call(watchFetchReportPassport),
        call(watchFetchSetReportPassport),
    ]);
}